import React from 'react'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'
import Modal from 'react-modal'

import i18n from 'Pods/Shared/I18n' // Needed for SSR
import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'

class ProductLicense extends React.Component {
  constructor() {
    super()

    this.state = {
      modalIsOpened: false,
    }

    this.onModalOpen = this.onModalOpen.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
  }

  onModalOpen() {
    this.setState({ modalIsOpened: true })
  }

  onModalClose() {
    this.setState({ modalIsOpened: false })
  }

  render() {
    const licenseTooltip = this.props.t(`license.tooltips.${this.props.type}`)

    return (
      <div className="product-license">
        <Tooltip
          id="propductLicenseInfo"
          content={licenseTooltip}
          className="u-inline-block"
          tooltipClassName="tooltip--interactive tooltip--license-info"
          delayHide={300}
          html
        >
          {this.props.title}
        </Tooltip>

        <button type="button" className="btn btn-transparent product-license__info" onClick={this.onModalOpen}>
          <Icon type={['far', 'info-circle']} />
        </button>

        {this.state.modalIsOpened && (
          <Modal
            isOpen
            shouldCloseOnOverlayClick
            onRequestClose={this.onModalClose}
            contentLabel="Modal"
            ariaHideApp={false}
            className={{
              base: '',
              afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
              beforeClose: 'overlay-modal--container_before-close',
            }}
            overlayClassName={{
              base: 'overlay-modal--background',
              afterOpen: 'overlay-modal--background_after-open',
              beforeClose: 'overlay-modal--background_before-close',
            }}
          >
            <div className="overlay-modal">
              <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
                <Icon type={['fal', 'times']} color="grey-dark" />
              </button>
              <div className="overlay-modal--content overlay-modal--jobs">
                <div className="l-inner-large">
                  <h2 className="modal-title">{this.props.title}</h2>
                  <span dangerouslySetInnerHTML={{ __html: this.props.licenseText }} />
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

ProductLicense.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}

export default withNamespaces('product')(ProductLicense)
